module.exports = {
    MOCK: true,
    serviceTestHost: "http://localhost:3000/",
    apiRoot: window.nw ? "http://simple.techchina.org.cn/web" : "/web",
}